<ng-container *ngIf="!errorType">
  <div
    [ngClass]="{ side: previewMode === 'side', popup: previewMode === 'popup' }"
    [ngStyle]="previewMode === 'side' ? { 'padding-bottom': paddingBottom } : {}"
  >
    <div *ngIf="!loaded" class="loader">
      <loader-overlay [darkOnly]="previewMode === 'popup'" [styles]="{ backgroundColor: 'transparent', backdropFilter: 'none' }">
      </loader-overlay>
    </div>
    <ngx-codejar
      *ngIf="loaded"
      [highlightMethod]="highlightMethod"
      [code]="code"
      [showLineNumbers]="true"
      (mouseup)="mouseup($event)"
      (auxclick)="auxclick($event)"
      (mousedown)="mousedown($event)"
      (click)="onClick($event)"
      (dragover)="$event.preventDefault()"
      #codejar
    ></ngx-codejar>
  </div>
</ng-container>

<ng-container *ngIf="errorType">
  <error-preview
    [errorType]="errorType"
    [previewMode]="previewMode"
    [icon]="model.icon"
    (reload)="reload.emit()"
    (download)="download.emit()"
    (open)="open.emit()"
  >
  </error-preview>
</ng-container>
